var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuantityArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0003 0.0831308C4.14921 0.0838814 4.2961 0.117773 4.43029 0.182347C4.56449 0.246922 4.68262 0.340558 4.77613 0.456463L7.23196 3.43146C7.37547 3.61057 7.46577 3.82638 7.49259 4.05431C7.5194 4.28224 7.48165 4.51311 7.38363 4.72063C7.30413 4.90098 7.1744 5.05464 7.00993 5.16325C6.84547 5.27186 6.65321 5.33084 6.45613 5.33313L1.54446 5.33313C1.34738 5.33084 1.15512 5.27186 0.990655 5.16325C0.826187 5.05464 0.696458 4.90098 0.616962 4.72063C0.518943 4.51311 0.481189 4.28224 0.508004 4.05431C0.534819 3.82638 0.625124 3.61057 0.768628 3.43146L3.22446 0.456463C3.31797 0.340558 3.4361 0.246922 3.5703 0.182347C3.70449 0.117773 3.85138 0.0838814 4.0003 0.0831308Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantityArrow);
export default __webpack_public_path__ + "static/media/quantity-arrow.46dc6fb2.svg";
export { ForwardRef as ReactComponent };